import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about-page">
      <div className="container">
        <h1 className="page-title">회사소개</h1>
        
        <section className="about-section">
          <div className="company-info">
            <h2>주식회사 애드플러스디벨롭먼트</h2>
            <p className="company-english">AdPlus Development Co., Ltd.</p>
          </div>
          
          <div className="info-grid">
            <div className="info-item">
              <h3>설립일</h3>
              <p>2025년 8월</p>
            </div>
            
            <div className="info-item">
              <h3>주요 사업분야</h3>
              <ul>
                <li>소프트웨어 개발 및 공급업</li>
                <li>광고대행업</li>
              </ul>
            </div>
            
            <div className="info-item">
              <h3>비전</h3>
              <p>혁신적인 기술과 창의적인 솔루션으로 고객의 성공을 돕는 파트너</p>
            </div>
            
            <div className="info-item">
              <h3>핵심가치</h3>
              <ul>
                <li>고객 중심의 서비스</li>
                <li>기술 혁신</li>
                <li>신뢰와 투명성</li>
                <li>지속 가능한 성장</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default About;